import { ClipboardList, FlaskConical, Gauge, KeyRound, Layers, PlayCircle, ScrollText, Users, Waypoints } from 'lucide-react'
import type { LucideIcon } from 'lucide-react'
import type { FileRoutesByTo } from '@/routeTree.gen'

import type { Capability } from '@/lib/session'

export interface NavItem {
  to: keyof FileRoutesByTo
  label: string
  icon: LucideIcon
  /** Shown only to callers with this capability (the server enforces it regardless). */
  requires?: Capability
}

export interface NavGroup {
  label: string
  items: NavItem[]
}

export const NAV_GROUPS: NavGroup[] = [
  {
    label: 'Testing',
    items: [
      { to: '/', label: 'Overview', icon: Gauge },
      { to: '/cases', label: 'Test cases', icon: ClipboardList },
      { to: '/suites', label: 'Suites', icon: Layers },
      { to: '/runs', label: 'Runs', icon: PlayCircle },
    ],
  },
  {
    label: 'Integrations',
    items: [{ to: '/jira', label: 'Jira', icon: Waypoints }],
  },
  {
    label: 'Administration',
    items: [
      { to: '/admin/users', label: 'Users', icon: Users, requires: 'manageUsers' },
      { to: '/admin/audit', label: 'Audit log', icon: ScrollText, requires: 'viewAudit' },
      { to: '/settings', label: 'Access & MCP', icon: KeyRound },
    ],
  },
]

export const PRODUCT = { name: 'Testbench', icon: FlaskConical }
